import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { useProfile } from 'components/use_profile'
import { autofillDataSelector } from 'selectors/scheduling'
import { spotsParamSelector } from 'selectors'
import { isReschedulingSelector } from 'selectors/current_invitee'
import { getSalt } from 'services/request_id'

import ReschedulingForm from './rescheduling_form'
import SchedulingFormV2 from './scheduling_form_feature'

const BookingForm = () => {
  const match = useRouteMatch()
  const autofillData = useSelector(autofillDataSelector)
  const isRescheduling = useSelector(isReschedulingSelector)
  const { spotStartTime } = match.params
  const requestKeySalt = getSalt()
  const spotStartTimes = useSelector(spotsParamSelector)
  const profile = useProfile()

  return (isRescheduling ? (
    <ReschedulingForm
      spotStartTime={spotStartTime}
      autofillData={autofillData}
      requestKeySalt={requestKeySalt}
    />
  )
    : (
      <SchedulingFormV2
        spotStartTime={spotStartTime}
        spotStartTimes={spotStartTimes}
        requestKeySalt={requestKeySalt}
        profile={profile}
      />
    )
  )
}

export default BookingForm
